import { isFalsy } from 'utility-types';
import { create } from 'zustand';
import type { ToastInfos, ToastProps } from '@/interfaces/component/toast.interface';

interface ToastState extends ToastProps {
  setShowToast: (showToast: boolean) => void;
  setToastInfos: (toastInfos: ToastInfos) => void;
  cleatToastInfos: () => void;
}

const baseToastInfos = {
  text: '',
  redirectPathOnCloseToast: undefined,
  onCloseToast: undefined,
  children: undefined
};
export const useToastStore = create<ToastState>((set) => ({
  showToast: false,
  toastInfos: baseToastInfos,
  anchor: { vertical: 'bottom', horizontal: 'center' },
  setShowToast: (showToast) =>
    set((state) => {
      if (isFalsy(state.toastInfos)) {
        return state;
      }
      return { ...state, showToast };
    }),
  setToastInfos: (toastInfos) => set((state) => ({ ...state, toastInfos })),
  cleatToastInfos: () => set((state) => ({ ...state, toastInfos: baseToastInfos }))
}));
